import appBulkcredits from "../../views/appSettings/bulkcredits.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "bulkcredits";
  const params = ["page", "limit"];

  $stateProvider.state("bulkcredits", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBulkcredits,
      },
    },
    reloadOnSearch: false,
    data: { title: "Bulkcredits" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bulkcredits/bulkcredits.urls.js